import Vue from 'vue'
import Router from 'vue-router'
import Menu from './views/menu/Menu.vue';
import Login from './views/login/login.vue';
import Welcome from './views/welcome/welcome.vue';
import Recharge from './views/recharge/recharge.vue';
import UserList from './views/usermanage/userlist.vue';
import AdminList from './views/setting/adminlist.vue';
import GameList from './views/game/gamelist.vue';
import GameAdd from './views/game/gameadd.vue';
import GameEdit from './views/game/gameedit.vue';
import GameRole from './views/game/gamerole.vue';
import RoleManage from './views/setting/rolemanage.vue';
import Active from './views/setting/active.vue';
import Day from './views/setting/day.vue';
import AuthManage from './views/setting/authmanage.vue';
import AdminCoin from './views/recharge/admincoin.vue';
import ChildrenCoin from './views/recharge/childrencoin.vue';
import UserCoin from './views/recharge/usercoin.vue';
import UserCoinLogList from './views/recharge/usercoinloglist.vue';
import AdminCoinLogList from './views/recharge/admincoinloglist.vue';
import adminOrder from './views/recharge/coinloglist.vue';
import OrderList from './views/order/orderlist.vue';
import OrderDetail from './views/order/orderdetail.vue';
import OrderCount from './views/order/ordercount.vue';
import GamePercentage from './views/percentage/gamepercentage.vue';
import AdminPercentage from './views/percentage/adminpercentage.vue';
import OrderPercentage from './views/percentage/orderpercentage.vue';
import MyShare from './views/percentage/myshare.vue';
import MyPercentage from './views/percentage/mypercentage.vue';
import ModifyPassword from './views/welcome/modifypassword.vue';
import ModifyPayWord from './views/welcome/modifypayword.vue';
import ModifyPhone from './views/welcome/modifyphone.vue';
import ModifyUserinfo from './views/welcome/modifyuserinfo.vue';
import AdminAdd from './views/setting/adminadd.vue';
import AdminEdit from './views/setting/adminedit.vue';
import AdminExamine from './views/setting/adminexamine.vue';
import UserAdd from './views/usermanage/useradd.vue';
import RoleAdd from './views/setting/roleadd.vue';
import UserChannel from './views/usermanage/childuserlist.vue';
import UserDetail from './views/usermanage/userdetial.vue';
import CashOut from './views/recharge/cashout.vue';
import MyCashOut from './views/percentage/mycashout.vue';
import Statistics from './views/setting/statistics.vue';
import MobileRechargeAdmin from './views/mobile/rechargeadmin.vue';
import MobileRechargeUser from './views/mobile/rechargeuser.vue';
import MobileLogin from './views/mobile/mobilelogin.vue';
import MobileHome from './views/mobile/mobilehome.vue';
import Select from './views/mobile/select.vue';
import GiftRecord from "./views/gift/giftrecord";
import GiftList from "./views/gift/giftlist";
import GiftAdd from "./views/gift/giftadd";
import GiftEdit from "./views/gift/giftedit";
import provideList from "./views/award/providelist";
import drawAddNum from "./views/draw/drawAddNum";
import ExtendList from "./views/game/extend/extendlist"
import ExtendAdd from "./views/game/extend/extendadd"
import ExtendEdit from "./views/game/extend/extendedit"
import ContentList from "./views/game/content/contentlist.vue"
import CodeList from "./views/gift/code/codelist"
import CodeAdd from "./views/gift/code/codeadd"
import RedAdd from "./views/gift/red/redadd"
import RedPool from "./views/gift/red/redpool"
import OnlineList from "./views/online/onlinelist"
import WeChatList from "./views/usermanage/wechatlist"
import TransactionOrder from "./views/transaction/transactionlist.vue"
import TransactionGoods from "./views/transaction/transactionGoods"
import Material from "./views/transaction/material"
import Shout from "./views/setting/shoutlist"
import ShoutAddNum from "./views/draw/shoutAddNum"
import ShopOrder from "./views/transaction/shopOrder";
import CashPool from './views/transaction/cashPool'
import OpenServer from './views/game/openServer/serverList'
import ServerAdd from './views/game/openServer/serverAdd'
import GameAudit from './views/game/audit/gameAuditList'
import UserWelfare from './views/usermanage/UserWelfare'
import SupportMain from './views/htgl/supportmain.vue'
import SupportLog from './views/htgl/supportlog.vue'
import RegisterDraw from './views/htgl/registerDraw.vue'
import RegisterDrawAdd from './views/htgl/registerDrawAdd.vue'
import OpenZoneList from "@/views/htgl/openZoneList.vue";
import OpenZoneAdd from "@/views/htgl/openZoneAdd.vue";
import TransactionHstOrder from "@/views/transaction/hstOrder.vue"
import Blacklist from "@/views/setting/blacklist.vue"
import UserChangeTie from "@/views/usermanage/userChangeTieList.vue"
import ContentEdit from "@/views/game/content/contentEdit.vue";
import ContentAdd from "@/views/game/content/contentAdd.vue";
import UserOrder from "@/views/order/userOrder.vue";
import ShjRedCashout from "@/views/transaction/shjRedCashout.vue";
import Supportlist from "@/views/usermanage/supportlist.vue";
import ThirdChannelList from './views/setting/thirdChannelList.vue';
import ThirdChannelAdd from './views/setting/thirdChannelAdd.vue';
import ThirdChannelEdit from './views/setting/thirdChannelEdit.vue';
import UserBind from './views/recharge/userbind.vue';
import WelfareLimit from "@/views/setting/welfareLimit.vue";

Vue.use(Router)
export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/mobile/login',
            name: 'MobileLogin',
            component: MobileLogin,
            meta: {
                title: '移动端登录'
            }
        },
        {
            path: '/mobile/home',
            name: 'MobileHome',
            component: MobileHome,
            meta: {
                title: '移动端首页'
            }
        },
        {
            path: '/mobile/rechargeAdmin',
            name: 'MobileRechargeAdmin',
            component: MobileRechargeAdmin,
            meta: {
                title: '移动端给会长充值'
            }
        },
        {
            path: '/mobile/rechargeUser',
            name: 'MobileRechargeUser',
            component: MobileRechargeUser,
            meta: {
                title: '移动端给玩家充值'
            }
        },
        {
            path: '/mobile/select',
            name: 'Select',
            component: Select,
            meta: {
                title: '福利抽奖'
            }
        },
        {
            path: '/',
            name: 'Menu',
            component: Menu,
            children: [//每个子路由对应了一个导航栏的选项，点击选项后跳转到相应路由，相应模块显示在插槽位置。
                {
                    path: '/home',
                    name: 'welcome',
                    component: Welcome,
                    meta: {
                        // 页面标题title
                        title: '数据统计'
                    }
                },
                {
                    path: '/userList',
                    name: 'userList',
                    component: UserList,
                    meta: {
                        // 页面标题title
                        title: '用户列表'
                    }
                },
                {
                    path: '/userChannel',
                    name: 'UserChannel',
                    component: UserChannel,
                    meta: {
                        // 页面标题title
                        title: '渠道用户'
                    }
                },
                {
                    path: '/userList/userAdd',
                    name: 'UserAdd',
                    component: UserAdd,
                    meta: {
                        // 页面标题title
                        title: '用户新增'
                    }
                },
                {
                    path: '/userList/userDetail/*',
                    name: 'UserDetail',
                    component: UserDetail,
                    meta: {
                        // 页面标题title
                        title: '用户详情'
                    }
                },
                {
                    path: '/userChannel/userDetail/*',
                    name: 'UserDetail',
                    component: UserDetail,
                    meta: {
                        // 页面标题title
                        title: '用户详情'
                    }
                },
                {
                    path: '/adminList',
                    name: 'AdminList',
                    component: AdminList,
                    meta: {
                        // 页面标题title
                        title: '管理员管理'
                    }
                },
                {
                    path: '/gameList',
                    name: 'GameList',
                    component: GameList,
                    meta: {
                        // 页面标题title
                        title: '游戏列表'
                    }
                },
                {
                    path: '/gameList/gameAdd',
                    name: 'GameAdd',
                    component: GameAdd,
                    meta: {
                        // 页面标题title
                        title: '游戏新增'
                    }
                },
                {
                    path: '/gameList/gameEdit/*',
                    name: 'GameEdit',
                    component: GameEdit,
                    meta: {
                        // 页面标题title
                        title: '游戏编辑'
                    }
                },
                {
                    path: '/gameRole',
                    name: 'GameRole',
                    component: GameRole,
                    meta: {
                        // 页面标题title
                        title: '游戏角色'
                    }
                },
                {
                    path: '/game/server/list',
                    name: 'OpenServer',
                    component: OpenServer,
                    meta: {
                        title: '开服列表'
                    }
                },
                {
                    path: '/game/server/add',
                    name: 'ServerAdd',
                    component: ServerAdd,
                    meta:{
                        title: '添加开服时间'
                    }
                },
                {
                  path: '/game/audit/list',
                  name: 'GameAudit',
                  component: GameAudit,
                  meta:{
                      title: '游戏审核'
                  }
                },
                {
                    path: '/roleManage',
                    name: 'RoleManage',
                    component: RoleManage,
                    meta: {
                        // 页面标题title
                        title: '角色管理'
                    }
                },
                {
                    path: '/roleManage/authManage',
                    name: 'AuthManage',
                    component: AuthManage,
                    meta: {
                        // 页面标题title
                        title: '角色授权'
                    }
                },
                {
                    path: '/roleManage/roleAdd',
                    name: 'RoleAdd',
                    component: RoleAdd
                },
                {
                    path: '/active',
                    name: 'Active',
                    component: Active,
                    meta: {
                        // 页面标题title
                        title: '留存'
                    }
                },
                {
                    path: '/day',
                    name: 'Day',
                    component: Day,
                    meta: {
                        // 页面标题title
                        title: '留存'
                    }
                },
                {
                    path: '/adminCoin',
                    name: 'AdminCoin',
                    component: AdminCoin,
                    meta: {
                        // 页面标题title
                        title: '给会长充值'
                    }
                },
                {
                    path: '/statistics',
                    name: 'Statistics',
                    component: Statistics,
                    meta: {
                        // 页面标题title
                        title: '统计页面'
                    }
                },
                {
                    path: '/childrenCoin',
                    name: 'ChildrenCoin',
                    component: ChildrenCoin,
                    meta: {
                        // 页面标题title
                        title: '给下级充值'
                    }
                },
                {
                    path: '/userCoin',
                    name: 'UserCoin',
                    component: UserCoin,
                    meta: {
                        // 页面标题title
                        title: '给玩家充值'
                    }
                },
                {
                    path: '/userBind',
                    name: 'UserBind',
                    component: UserBind,
                    meta: {
                        // 页面标题title
                        title: '给玩家充绑币'
                    }
                },
                {
                    path: '/adminCoinLogList',
                    name: 'AdminCoinLogList',
                    component: AdminCoinLogList,
                    meta: {
                        // 页面标题title
                        title: '会长充值记录'
                    }
                },
                {
                    path: '/adminOrder',
                    name: 'adminOrder',
                    component: adminOrder,
                    meta: {
                        // 页面标题title
                        title: '发币订单'
                    }
                },
                {
                    path: '/userCoinLogList',
                    name: 'UserCoinLogList',
                    component: UserCoinLogList,
                    meta: {
                        // 页面标题title
                        title: '玩家充值记录'
                    }
                },
                {
                    path: '/orderList',
                    name: 'OrderList',
                    component: OrderList,
                    meta: {
                        // 页面标题title
                        title: '订单查询'
                    }
                },
                {
                    path: '/orderList/orderDetail/*',
                    name: 'OrderDetail',
                    component: OrderDetail,
                    meta: {
                        // 页面标题title
                        title: '订单详情'
                    }
                },
                {
                    path: '/orderCount',
                    name: 'OrderCount',
                    component: OrderCount,
                    meta: {
                        // 页面标题title
                        title: '订单统计'
                    }
                },
                {
                    path: '/uerOrder',
                    name: 'UserOrder',
                    component: UserOrder,
                    meta: {
                        title: '用户订单'
                    }
                },
                {
                    path: '/gamePercentage',
                    name: 'GamePercentage',
                    component: GamePercentage,
                    meta: {
                        // 页面标题title
                        title: '游戏提成配置'
                    }
                },
                {
                    path: '/adminPercentage',
                    name: 'AdminPercentage',
                    component: AdminPercentage,
                    meta: {
                        // 页面标题title
                        title: '会长提成配置'
                    }
                },
                {
                    path: '/orderPercentage',
                    name: 'OrderPercentage',
                    component: OrderPercentage,
                    meta: {
                        // 页面标题title
                        title: '提成查询'
                    }
                },
                {
                    path: '/myShare',
                    name: 'MyShare',
                    component: MyShare,
                    meta: {
                        // 页面标题title
                        title: '提成查询'
                    }
                },
                {
                    path: '/myPercentage',
                    name: 'MyPercentage',
                    component: MyPercentage,
                    meta: {
                        // 页面标题title
                        title: '我的提成配置'
                    }
                },
                {
                    path: '/modifyPassword',
                    name: 'ModifyPassword',
                    component: ModifyPassword,
                    meta: {
                        // 页面标题title
                        title: '修改登录密码'
                    }
                },
                {
                    path: '/modifyPayWord',
                    name: 'ModifyPayWord',
                    component: ModifyPayWord,
                    meta: {
                        // 页面标题title
                        title: '修改支付密码'
                    }
                },
                {
                    path: '/modifyPhone',
                    name: 'ModifyPhone',
                    component: ModifyPhone,
                    meta: {
                        // 页面标题title
                        title: '修改电话号码'
                    }
                },
                {
                    path: '/modifyUserinfo',
                    name: 'ModifyUserinfo',
                    component: ModifyUserinfo,
                    meta: {
                        // 页面标题title
                        title: '修改个人信息'
                    }
                },
                {
                    path: '/adminList/adminAdd',
                    name: 'AdminAdd',
                    component: AdminAdd,
                    meta: {
                        // 页面标题title
                        title: '新增管理员'
                    }
                },
                {
                    path: '/adminList/adminEdit/*',
                    name: 'AdminEdit',
                    component: AdminEdit,
                    meta: {
                        // 页面标题title
                        title: '编辑管理员'
                    }
                },
                {
                    path: '/adminList/adminExamine/*',
                    name: 'AdminExamine',
                    component: AdminExamine,
                    meta: {
                        // 页面标题title
                        title: '管理员审核'
                    }
                },
                {
                    path: '/cashOut',
                    name: 'CashOut',
                    component: CashOut,
                    meta: {
                        // 页面标题title
                        title: '会长提现记录'
                    }
                },
                {
                    path: '/myCashOut',
                    name: 'MyCashOut',
                    component: MyCashOut,
                    meta: {
                        // 页面标题title
                        title: '我的提现记录'
                    }
                },
                {
                    path: '/gift/record',
                    name: 'GiftRecord',
                    component: GiftRecord,
                    meta: {
                        // 页面标题title
                        title: '礼包领取记录'
                    }
                },
                {
                    path: '/gift/list',
                    name: 'GiftList',
                    component: GiftList,
                    meta: {
                        // 页面标题title
                        title: '填写礼包码'
                    }
                },
                {
                    path: '/gift/list',
                    name: 'GiftList',
                    component: GiftList,
                    meta: {
                        // 页面标题title
                        title: '礼包列表'
                    }
                },
                {
                    path: '/gift/add',
                    name: 'GiftAdd',
                    component: GiftAdd,
                    meta: {
                        // 页面标题title
                        title: '礼包管理'
                    }
                },
                {
                    path: '/gift/edit/*',
                    name: 'GiftEdit',
                    component: GiftEdit,
                    meta: {
                        // 页面标题title
                        title: '礼包编辑'
                    }
                },

                {
                    path: '/award/provide',
                    name: 'provideList',
                    component: provideList,
                    meta: {
                        // 页面标题title
                        title: '抽奖记录'
                    }
                },
                {
                    path: '/draw/num',
                    name: 'drawAddNum',
                    component: drawAddNum,
                    meta: {
                        title: '抽奖次数'
                    }
                },

                //GameExtend
                {
                    path: '/game/extend/list',
                    name: 'ExtendList',
                    component: ExtendList,
                    meta: {
                        title: '游戏推广管理'
                    }
                },

                {
                    path: '/game/extend/add',
                    name: 'ExtendAdd',
                    component: ExtendAdd,
                    meta: {
                        title: '游戏推广新增'
                    }
                },

                {
                    path: '/game/extend/edit/*',
                    name: 'ExtendEdit',
                    component: ExtendEdit,
                    meta: {
                        title: '游戏推广编辑'
                    }
                },

                //GameGuide
                {
                    path: '/content/list',
                    name: 'ContentList',
                    component: ContentList,
                    meta: {
                        title: '游戏攻略列表'
                    }
                },
                {
                    path: '/content/edit/*',
                    name: 'ContentEdit',
                    component: ContentEdit,
                    meta: {
                        title: '游戏攻略编辑'
                    }
                },
                {
                    path: '/content/add',
                    name: 'ContentAdd',
                    component: ContentAdd,
                    meta: {
                        title: '游戏攻略添加'
                    }
                },
                {
                    path: '/gift/code/list/*',
                    name: 'CodeList',
                    component: CodeList,
                    meta: {
                        title: '礼包码列表'
                    }
                },
                {
                    path: '/gift/code/add/*',
                    name: 'CodeAdd',
                    component: CodeAdd,
                    meta: {
                        title: '礼包码添加'
                    }
                },
                {
                    path: '/red/add',
                    name: 'RedAdd',
                    component: RedAdd,
                    meta: {
                        title: '红包发放'
                    }
                },
                {
                    path: '/red/redpool',
                    name: 'RedPool',
                    component: RedPool,
                    meta: {
                        title: '红包发放'
                    }
                },{
                    path: '/online',
                    name: 'OnlineList',
                    component: OnlineList,
                    meta: {
                        title: '在线人数'
                    }
                },
                {
                    path: '/wechat',
                    name: 'WeChatList',
                    component: WeChatList,
                    meta: {
                        title: '绑定微信'
                    }
                },
                {
                    path: '/userWelfare',
                    name: 'UserWelfare',
                    component: UserWelfare,
                    meta: {
                        title: '用户福利'
                    }
                },
                {
                    path: '/transactionOrder',
                    name: 'TransactionOrder',
                    component: TransactionOrder,
                    meta: {
                        title: '交易订单'
                    }
                },
                {
                    path: '/transactionGoods',
                    name: 'TransactionGoods',
                    component: TransactionGoods,
                    meta: {
                        title: '商品列表'
                    }
                },
                {
                    path: '/material',
                    name: 'Material',
                    component: Material,
                    meta: {
                        title: '素材管理'
                    }
                },
                {
                    path: '/shout',
                    name: 'Shout',
                    component: Shout,
                    meta: {
                        title: '游戏喊话记录'
                    }
                },
                {
                    path: '/shoutNum',
                    name: 'ShoutAddNum',
                    component: ShoutAddNum,
                    meta: {
                        title: '喊话次数'
                    }
                },
                {
                    path: '/shopOrder',
                    name: 'ShopOrder',
                    component: ShopOrder,
                    meta:{
                        title: '商城订单列表'
                    }
                },
                {
                    path: '/cashPool',
                    name: 'CashPool',
                    component: CashPool,
                    meta:{
                        title: '奖池信息'
                    }
                },
                {
                    path: '/supportMain',
                    name: 'SupportMain',
                    component: SupportMain,
                    meta:{
                        title: '游戏扶持发放'
                    }
                },
                {
                    path: '/supportLog',
                    name: 'SupportLog',
                    component: SupportLog,
                    meta:{
                        title: '扶持发放记录'
                    }
                },
                {
                    path: '/registerDraw',
                    name: 'RegisterDraw',
                    component: RegisterDraw,
                    meta:{
                        title: "注册抽奖"
                    }
                },
                {
                    path: '/registerDrawAdd',
                    name: 'RegisterDrawAdd',
                    component: RegisterDrawAdd,
                    meta: {
                        title: "添加预设"
                    }
                },
                {
                    path: '/openZone',
                    name: 'OpenZoneList',
                    component: OpenZoneList,
                    meta: {
                        title: "开区红包"
                    }
                },
                {
                    path: '/openZoneAdd',
                    name: 'OpenZoneAdd',
                    component: OpenZoneAdd,
                    meta: {
                        title: "添加开区红包"
                    }
                },
                {
                    path: '/hstOrder',
                    name: 'TransactionHstOrder',
                    component: TransactionHstOrder,
                    meta: {
                        title: "海神套预定订单"
                    }
                },
                {
                    path: '/blacklist',
                    name: 'Blacklist',
                    component: Blacklist,
                    meta: {
                        title: "黑名单列表"
                    }
                },
                {
                    path: '/userChange',
                    name: 'UserChangeTie',
                    component: UserChangeTie,
                    meta: {
                        title: '用户换绑记录'
                    }
                },
                {
                    path: "/shjRedCashOut",
                    name: "ShjRedCashOut",
                    component: ShjRedCashout,
                    meta: {
                        title: "山海经红包提现"
                    }
                },
                {
                    path: "/support",
                    name: "SupportList",
                    component: Supportlist,
                    meta: {
                        title: "扶持号列表"
                    }
                },
                {
                    path: '/thirdChannelList',
                    name: 'ThirdChannelList',
                    component: ThirdChannelList,
                    meta: {
                        // 页面标题title
                        title: '渠道号绑定记录'
                    }
                },
                {
                    path: '/thirdChannelList/thirdChannelAdd',
                    name: 'ThirdChannelAdd',
                    component: ThirdChannelAdd,
                    meta: {
                        // 页面标题title
                        title: '新增渠道号绑定'
                    }
                },
                {
                    path: '/thirdChannelList/thirdChannelEdit',
                    name: 'ThirdChannelEdit',
                    component: ThirdChannelEdit,
                    meta: {
                        // 页面标题title
                        title: '编辑渠道号绑定'
                    }
                },
                {
                    path: '/welfareDraw',
                    name: 'welfareLimit',
                    component: WelfareLimit,
                    meta: {
                        title: '福利抽奖'
                    }
                },
            ]
        }
    ]
})